/* eslint-disable @typescript-eslint/no-var-requires */

const {
  renderApp
} = require(`./internal/${"none"}-auth-app-renderer`);
export { renderApp };